import { Button, Input, Select, Tag } from "antd";
import { useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { FiUser } from "react-icons/fi";

import {
  type MessageType,
  type TicketsMainProps,
} from "../../../_lib/_store/interfaces/tickets";

const { TextArea } = Input;

export const TicketsMain = ({
  ticket,
  messages,
  onSendMessage,
}: TicketsMainProps) => {
  const [reply, setReply] = useState("");
  const [status, setStatus] = useState("Keep open");

  if (!ticket) {
    return (
      <main className="tickets-main">
        <div className="empty-state">
          <FaUserCircle size={60} color="#94a3b8" />
          <p>Select a ticket to view details</p>
        </div>
      </main>
    );
  }

  const formatTime = (date: Date) =>
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const formatDateTag = (date: Date) => {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString();
  };

  const handleSend = () => {
    if (!reply.trim()) return;

    const newMessage: MessageType = {
      sender: ticket.name,
      text: reply,
      time: new Date(),
      type: "person",
    };

    onSendMessage(ticket.id, newMessage);
    setReply("");
  };

  return (
    <main className="tickets-main">
      {/* HEADER */}
      <header className="ticket-header">
        <h3 className="ticket-title">{ticket.text}</h3>
        <div className="priority-wrapper">
          <span style={{ color: ticket.color }}>{ticket.icon}</span>
          <Tag
            className="badge"
            color={
              ticket.badge === "high"
                ? "error"
                : ticket.badge === "medium"
                  ? "gold"
                  : "green"
            }
          >
            {ticket.badge} priority
          </Tag>
        </div>
      </header>

      <div className="ticket-meta">
        <div className="user-info">
          <FiUser size={15} style={{ marginRight: "6px" }} />
          <span>
            {ticket.name} • {ticket.name.toLowerCase().split(" ").join(".")}
            @example.com
          </span>
        </div>
      </div>

      {/* CHAT */}
      <div className="ticket-chat">
        {messages.length > 0 &&
          messages.map((msg: MessageType, i: number) => {
            const msgDate = new Date(msg.time);
            const prevMsgDate = i > 0 ? new Date(messages[i - 1].time) : null;

            const showDateTag =
              i === 0 || msgDate.toDateString() !== prevMsgDate?.toDateString();

            return (
              <>
                {showDateTag && (
                  <div className="date-tag-wrapper">
                    <Tag className="date-tag" color="blue">
                      {formatDateTag(msgDate)}
                    </Tag>
                  </div>
                )}
                <div className={`message ${msg.type}`}>
                  <span className="time">
                    {msg.sender} • {formatTime(msgDate)}
                  </span>
                  <p>{msg.text}</p>
                </div>
              </>
            );
          })}
      </div>

      {/* REPLY */}
      <div className="ticket-reply">
        <TextArea
          rows={4}
          placeholder="Type your response..."
          value={reply}
          onChange={(e) => setReply(e.target.value)}
        />
        <div className="reply-actions">
          <Select
            value={status}
            onChange={(value) => setStatus(value)}
            options={[
              { value: "Keep open", label: "Keep open" },
              { value: "In progress", label: "In progress" },
              { value: "Mark resolved", label: "Mark resolved" },
            ]}
          />
          <Button type="primary" disabled={!reply.trim()} onClick={handleSend}>
            Send Reply
          </Button>
        </div>
      </div>
    </main>
  );
};
